<template>
	<div id="index">
		<Header></Header>
		<Search></Search>
		<Nav></Nav>
		<div class="content">
			<div class="index-content">
				<div class="serve">
					<div class="serveup">
						<h4 class="title">有偿咨询</h4>
					</div>
					<div class="serconter">
						<div class="serconterlist">
							<ul>
								<li v-for="(item, index) in lister" class="clearfloat d-flex justify-content-center align-items-center" @click="serzf()" >
									<div class="sertext">
										<h5  v-text="item.title">item.title</h5>
										<p v-html="item.content" style="margin-bottom: 10px;"></p>
										<p >
											<span>更多>></span>
										</p>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div class="back-top" :class="{'active' : scroll_top}" @click="backTop">Top</div>
			</div>
		</div>
		<Foot></Foot>
		
		<div class="sebox" :class="poster_show ? 'active' : ''">
			<div class="seboxbj" @click="guanbiser()"></div>
			<div class="seboxcon">
				<img src="../../assets/images/wx.jpg" alt="">
			</div>
		</div>
	</div>
</template>

<script>
	let timeFun = null;
	import Header from "@/components/header/header";
	import Search from "@/components/search/search";
	import Nav from "@/components/nav/nav";
	import Foot from "@/components/foot/foot";

	export default {
		components: {
			Search,
			Header,
			Nav,
			Foot,
		},
		data() {
			return {
				scroll_top: false,
				poster_show: false,
				lister:[]
			};
		},
		created() {
			this.servers()
		},
		mounted() {
			let that = this;
			window.onscroll = function() {
				let scroll_top = document.documentElement.scrollTop || document.body.scrollTop;
				if(scroll_top >= 400){
					that.scroll_top = true;
				}else{
					that.scroll_top = false;
				}
				let floot_list = document.getElementsByClassName("floor-box");
				for (let i = 0; i < floot_list.length; i++) {
					if(scroll_top >= floot_list[i].offsetTop+165){
						that.floor_active = floot_list[i].parentNode.id;
					}
				}
			}
		},
		methods: {
			serzf(){
				let that = this;
				that.poster_show = !that.poster_show
			},
			guanbiser(){
				let that = this;
				that.poster_show = !that.poster_show
			},
			backTop() {
				this.common.backTop(20);
			},
			servers() {
				let that = this;
				let params = {
					page: 1,
					limit: 10
				}
				that.$api.server(params).then((res) => {
					if (res.code == 0) {
						that.lister = res.data.list
						console.log(res)
					}
				}).catch((err) => {
				});
			}
		}
	};
</script>

<style lang="scss" scoped>
	.w {
		position: relative;
	}

	.content {
		width: 100%;
		background-color: #f2f2f2;
		padding: 20px 0 42px 0;
		border-top: 2px solid #FF0E25;
		box-sizing: border-box;

		.index-content {
			width: 1000px;
			margin: 0 auto;
			.serve{
				width: 100%;
				box-sizing: border-box;
				.serveup{
					width: 100%;
					background: #fff;
					margin-bottom: 10px;
					.title{
						font-size: 18px;
						color: #333;
						height: 44px;
						line-height: 44px;
						padding: 0 14px 0 18px;
						box-sizing: border-box;
						font-weight: 500;
						position: relative;
						&::before{
							content: '';
							width: 3px;
							height: 20px;
							background: #FF0E25;
							position: absolute;
							top: 12px;
							left: 0;
						}
					}
				}
				.serconter{
					width: 100%;
					.serconterlist{
						width: 100%;
						ul li{
							width: 100%;
							height: 160px;
							border-radius: 4px;
							background: #fff;
							cursor: pointer;
							margin-bottom: 20px;
							.serimg{
								float: left;
								width: 160px;
								height: 160px;
								margin-right: 40px;
								img{
									display: block;
									width: 100%;
									height: 100%;
									object-fit: cover;
								}
							}
							.sertext{
								float: nonw;
								width: 100%;
								padding: 20px 40px;
								box-sizing: border-box;
								h5{
									font-size: 16px;
									color: #333;
									font-weight: 500;
									transition:.35s;
									-moz-transition: .35s;
									-webkit-transition: .35s;
									-o-transition: .35s;
									margin-bottom: 16px;
									overflow: hidden;
									white-space: nowrap;
									text-overflow: ellipsis;
								}
								p{
									font-size: 14px;
									color: #666;
									font-weight: 400;
									span{
										color: #ff0008;
										transition:.35s;
										-moz-transition: .35s;
										-webkit-transition: .35s;
										-o-transition: .35s;
									}
								}
							}
							&:hover .sertext h5{color: #ff0008;}
						}
					}
				}
				
			}
		}
	}
	
	.sebox{
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 99999;
		opacity: 0;
		visibility: hidden;
		transition: all 0.5s;
		.seboxbj{
			width: 100%;
			height: 100%;
			position: fixed;
			top: 0;
			left: 0;
			background: rgba(0,0,0,0.3);
			cursor: pointer;
		}
		.seboxcon{
			width: 400px;
			height: 550px;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%,-50%);
			img{
				display: block;
				width: 100%;
				height: 100%;
				transform: scale(0.2);
				transition:.6s;
				-moz-transition: .6s;
				-webkit-transition: .6s;
				-o-transition: .6s;
			}
		}
		&.active{opacity: 1;visibility: visible;}
		&.active .seboxcon img{transform: scale(1);}
	}
	
	.back-top {
		cursor: pointer;
		font-size: 14px;
		position: fixed;
		text-align: center;
		z-index: 9999;
		visibility: hidden;
		opacity: 0;
		transition: 1s;
		background: #121212;
		color: #ffffff;
		border-radius: 3px;
		padding: 12px;
		right: 50px;
		bottom: 45px;
	}
	.back-top.active{
		visibility: visible;
		opacity: 1;
		transition: 0.3s;
	}
</style>
